/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Yes_ButtonInputs */

const en_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_markers_yes_button = /** @type {(inputs: Markers_Yes_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Markers_Yes_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_yes_button = /** @type {((inputs?: Markers_Yes_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Yes_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_yes_button(inputs)
	if (locale === "de") return de_markers_yes_button(inputs)
	if (locale === "it") return it_markers_yes_button(inputs)
	if (locale === "ru") return ru_markers_yes_button(inputs)
	if (locale === "es") return es_markers_yes_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_yes_button(inputs)
	if (locale === "ja") return ja_markers_yes_button(inputs)
	if (locale === "hi") return hi_markers_yes_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_yes_button(inputs)
	return en_markers_yes_button(inputs)
});